import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'react-map-gl';

export default class CurrentLocationMarker extends PureComponent {
  render() {
    const { position } = this.props;
    return position?.length > 1
      ? (
        <Marker
          captureDrag={false}
          key={`${position}`}
          latitude={position[0]}
          longitude={position[1]}
        >
          <span className="white-circle" aria-label="Current location">
            <span className="blue-dot" />
          </span>
        </Marker>
      )
      : null;
  }
}
CurrentLocationMarker.propTypes = {
  position: PropTypes.arrayOf(PropTypes.number),
};
CurrentLocationMarker.defaultProps = {
  position: null,
};